// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"x9-z","button":"y9-z","disabled":"z9-z","creditCard":"A9-z","wrapper":"B9-z"};